import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Toast, Dialog, Search, List, Cell, Swipe, SwipeItem, Image as VanImage, Lazyload, Tag, Form, Field, Button, Popup} from 'vant';

Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Search);
Vue.use(List);
Vue.use(Cell);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Tag);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Popup);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
